<template>
	<div id="app">
		<!--    <div id="nav">-->
		<!--      <router-link to="/">Home</router-link> |-->
		<!--      <router-link to="/about">About</router-link>-->
		<!--    </div>-->
		<transition name="fade">
			<router-view/>
		</transition>
		<audio id="app-audio" src="./bgaudio.mp3" autoplay loop></audio>

	</div>
</template>

<script>

	export default {
		name: 'app',
		mounted() {
			this.$nextTick(function () {
				// Code that will run only after the
				// entire view has been rendered
				var audio = document.getElementById('app-audio')
				var promise = document.querySelector('audio').play()
				if (promise !== undefined) {
					promise.then(_ => {
						// Autoplay started!
					}).catch(error => {
						var compass = document.getElementById('compass')
						compass.onclick = function () {

							audio.play()
						}
					})
				}
			})

		}
	}
</script>


<style>


	@font-face {
		font-family: "hk-grotesk-boldlegacy";
		src: url("/fonts/HKGrotesk-BoldLegacy.woff");
	}

	@font-face {
		font-family: "hk-grotesk-semibold";
		src: url("/fonts/HKGrotesk-SemiBold.woff");
	}

	@font-face {
		font-family: "gothicdawn";
		src: url("/fonts/MB-GothicDawn_Font.ttf");
	}


	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;

	}

	#nav {
		padding: 30px;
	}

	#nav a {
		font-weight: bold;
		color: #2c3e50;
	}

	#nav a.router-link-exact-active {
		color: #42b983;
	}

	.page-nav-link {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.75));

	}

	.page-nav-link :hover {

		filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 1));
	}

	.link-image {
		max-width: 80px;
		max-height: 80px;
	}

	#link-left {
		left: 20px;
	}

	#link-right {
		right: 20px;
	}

	#link-center {
		left: 50%;
	}

	#link-bottom {
		left: 48%;
		top: unset;
		bottom: 20px;
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
	{
		opacity: 0;
	}


</style>
